<template>
	<ActivityLayout class="goal-kr-progress-activity">
		<template #badge>
			<ValueChangeActivityBadge />
		</template>
		<template #text>
			<p v-html="text"></p>
		</template>
		<template #timestamp>{{ activity.changedAt }}</template>
	</ActivityLayout>
</template>

<script>
import ActivityLayout from "../Activity/ActivityLayout.vue";
import ValueChangeActivityBadge from "../Activity/ValueChangeActivityBadge.vue";

export default {
	name: "GoalKRProgressActivity",
	components: {
		ActivityLayout,
		ValueChangeActivityBadge,
	},
	props: {
		/** { changedBy:String, changedAt:String, name:String, from:String, to:String } */
		activity: {
			type: Object,
			required: true,
		},
	},
	computed: {
		text() {
			const { to, from, changedBy, name, } = this.activity;
			const key = "text";
			return this.translate( key, {
				name,
				changedBy,
				to,
				from,
			} );
		},
	},
	methods: {
		translate( key, args = {} ) {
			return this.$t( `common-gokr.components.GoalKRProgressActivity.${ key }`, args );
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
